import _ from 'lodash'
import { DialogSchema } from '@feedyou-ai/feedbot-schema'

import { sanitizeText } from '../../../lib/sanitizeText'

export const actionTypes = {
  SET_DIALOG: 'SET_DIALOG'
} as const

export function setDialog(dialog: DialogSchema) {
  const dialogCopy = _.cloneDeep(dialog)
  dialogCopy.name = sanitizeText(dialogCopy.name)

  return { type: actionTypes.SET_DIALOG, payload: { dialog: dialogCopy } }
}

export type Action = ReturnType<typeof setDialog>
